<template>
  <div class="container-fluid">
    <el-switch
      active-color="#13ce66"
      inactive-color="#808080"
      v-model="openRPA"
      @change="updateRPA"
    />
    啟用RPA自動收錄履歷
    <template v-if="openRPA">
      <div class="page-tabs mt-4">
        <a
          :class="{ active: currentTab === 0 }"
          @click.prevent="(currentTab = 0), (confirmPassword = null)"
        >
          GMAIL
        </a>
        <a
          :class="{ active: currentTab === 1 }"
          @click.prevent="(currentTab = 1), (confirmPassword = null)"
        >
          O365
        </a>
      </div>
      <div class="card search-card">
        <ValidationObserver ref="setting" v-slot="{ handleSubmit, reset }">
          <form @reset.prevent="reset">
            <div class="card-body">
              <div class="form-row">
                <div class="col-md-4 col-sm-12">
                  <div class="form-group">
                    <label for="">信箱</label>
                    <input
                      class="form-control"
                      type="text"
                      placeholder="請輸入Email"
                      v-model.trim="setting.account"
                    />
                  </div>
                </div>
                <div class="col-md-3 col-sm-12">
                  <div class="form-group">
                    <ValidationProvider name="信箱密碼" vid="password">
                      <label for="">信箱密碼</label>
                      <input
                        class="form-control"
                        type="password"
                        placeholder="請輸入密碼"
                        v-model.trim="setting.password"
                      />
                    </ValidationProvider>
                  </div>
                </div>
                <div class="col-md-3 col-sm-12">
                  <div class="form-group">
                    <ValidationProvider
                      name="確認密碼"
                      v-slot="{ errors }"
                      :rules="{ required: setting.password ? true : false, confirmed: 'password' }"
                    >
                      <label for="">確認密碼</label>
                      <input
                        class="form-control"
                        type="password"
                        placeholder="請再次輸入密碼"
                        v-model.trim="confirmPassword"
                      />
                      <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="col-md-2 col-sm-12">
                  <div class="form-group">
                    <button
                      type="button"
                      class="btn btn-primary"
                      style="margin-top: 30px; margin-left: 10px"
                      @click="handleSubmit(updateSetting)"
                    >
                      儲存
                    </button>
                  </div>
                </div>
              </div>
              <div v-if="currentTab === 1" class="form-row">
                <div class="col-md-4 col-sm-12">
                  <div class="form-group">
                    <label for="">應用程式識別碼</label>
                    <input
                      class="form-control"
                      type="text"
                      placeholder="請輸入應用程式識別碼"
                      v-model.trim="setting.O365ClientId"
                    />
                  </div>
                </div>
                <div class="col-md-4 col-sm-12">
                  <div class="form-group">
                    <label for="">目錄識別碼</label>
                    <input
                      class="form-control"
                      type="text"
                      placeholder="請輸入目錄識別碼"
                      v-model.trim="setting.O365TenantId"
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "RpaParameter",

  data() {
    return {
      currentTab: 0,

      openRPA: null,

      setting: {},
      copySetting: {},
      confirmPassword: null,
    };
  },

  watch: {
    currentTab: function (e) {
      if (e === 0) {
        this.setting.account = this.copySetting.GmailAccount;
        this.setting.password = this.copySetting.GmailPassword;
        this.setting.O365ClientId = this.copySetting.O365ClientId;
        this.setting.O365TenantId = this.copySetting.O365TenantId;
      } else {
        this.setting.account = this.copySetting.O365Account;
        this.setting.password = this.copySetting.O365Password;
      }
      this.$refs.setting.reset();
    },
  },

  methods: {
    // 取得 RPA狀態
    getRPA() {
      this.updateLoading(true);
      this.$api.rpa.getRPAStatus().then((response) => {
        if (response.status === 200) {
          this.openRPA = response.data;
          if (this.openRPA) {
            this.getSetting();
          }
        }
        this.updateLoading(false);
      });
    },

    // 更新 RPA狀態
    updateRPA(status) {
      this.updateLoading(true);
      this.$api.rpa
        .putRPAStatus({
          Enabled: status,
          UpdateUser: this.$cookies.get("userId"),
        })
        .then(async (response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: status
                ? "啟用RPA自動收錄履歷功能"
                : "關閉RPA自動收錄履歷功能",
              type: "success",
              duration: 2500,
            });
            await this.getRPA();
          }
          this.updateLoading(false);
        });
    },

    // 取得 Email同步履歷 收信參數
    getSetting() {
      this.updateLoading(true);
      this.$api.rpa.getEmailSetting().then((response) => {
        if (response.status === 200) {
          this.copySetting = JSON.parse(JSON.stringify(response.data));
          this.setting = response.data;

          if (response.data.EmailType === "GMAIL") {
            this.currentTab = 0;
            this.setting.account = response.data.GmailAccount;
            this.setting.password = response.data.GmailPassword;
          } else {
            this.currentTab = 1;
            this.setting.account = response.data.O365Account;
            this.setting.password = response.data.O365Password;
          }

          this.confirmPassword = null;
        }
        this.updateLoading(false);
      });
    },

    // 更新 RPA設定
    updateSetting() {
      this.updateLoading(true);
      let data;
      if (this.currentTab === 0) {
        data = {
          EmailType: "GMAIL",
          GmailAccount: this.setting.account,
          GmailPassword: this.setting.password,
          O365Account: this.copySetting.O365Account,
          O365Password: this.copySetting.O365Password,
          O365ClientId: this.copySetting.O365ClientId,
          O365TenantId: this.copySetting.O365TenantId,
          UpdateUser: this.$cookies.get("userId"),
        };
      } else {
        data = {
          EmailType: "O365",
          O365Account: this.setting.account,
          O365Password: this.setting.password,
          O365ClientId: this.setting.O365ClientId,
          O365TenantId: this.setting.O365TenantId,
          GmailAccount: this.copySetting.GmailAccount,
          GmailPassword: this.copySetting.GmailPassword,
          UpdateUser: this.$cookies.get("userId"),
        };
      }
      this.$api.rpa.putEmailSetting(data).then(async (response) => {
        if (response.status === 200) {
          this.$notify({
            title: "成功",
            message: "儲存成功",
            type: "success",
            duration: 2500,
          });
          this.getSetting();
        }
        this.updateLoading(false);
      });
    },

    // loading
    ...mapActions(["updateLoading"]),
  },

  created() {
    this.getRPA();
  },
};
</script>

<style scoped>
.page-tabs {
  cursor: pointer;
}
</style>
